import PropTypes from 'prop-types';
import {Tooltip} from "@mui/material";
import {useEffect, useRef, useState} from "react";

function EllipsisContainer({value, children, debug}) {
    const [isEllipsis, setIsEllipsis] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        if(debug){
            debugger
        }
        const alreadySet = !!isEllipsis;
        if (elementRef.current && !alreadySet) {
            const el = elementRef.current.firstChild;
            const {scrollWidth, offsetWidth} = el;
            setIsEllipsis(scrollWidth > offsetWidth);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <span ref={elementRef} key={String(isEllipsis)} className='eliipsis-container'>
        <Tooltip title={isEllipsis ? value : ''} arrow>
            {children}
        </Tooltip>
            </span>
    )
}

EllipsisContainer.propTypes = {
    value: PropTypes.string
}

export default EllipsisContainer;

